// PRD 3.2: 推荐问题 Action Chips 组件
// 终端风味文本按钮：[ 问题文本 ]，点击后填入输入框并自动发送
// 纵向轮播：窗口固定显示 3 条，每 2s 上移 1 条，无缝循环（克隆首部至末尾）

const VISIBLE_COUNT = 3;
const INTERVAL_MS = 1500;
const TRANSITION_MS = 300; // 与 CSS .action-chips__track transition 时长一致

export class ActionChips {
  /**
   * @param {HTMLElement} container 渲染容器（#action-chips）
   */
  constructor(container) {
    this.container = container;
    /** @type {(text: string) => void} */
    this.onSelect = () => {};
    this.list = [];
    this.index = 0;
    this.timer = null;
    this.resetTimer = null;
    this.track = null;
    this.needsCarousel = false;
  }

  /** 控制显隐：空列表自动隐藏 */
  show() {
    this.container.style.display = '';
    // hide() 停止了轮播，show() 恢复显示时重启轮播（如果需要）
    if (this.needsCarousel) this.start();
  }

  hide() {
    this.container.style.display = 'none';
    this.stop();
  }

  /**
   * @param {(text: string) => void} cb
   */
  onSelectCb(cb) {
    this.onSelect = cb;
  }

  /**
   * @param {string[]} list
   */
  render(list) {
    this.stop();
    this.list = list;
    this.index = 0;

    if (list.length === 0) {
      this.container.replaceChildren();
      this.hide();
      return;
    }

    // 总数 ≤ 可见数：不需要轮播，直接平铺
    this.needsCarousel = list.length > VISIBLE_COUNT;

    const track = document.createElement('div');
    track.className = 'action-chips__track';

    list.forEach((text) => track.appendChild(this._buildChip(text)));

    // 克隆前 VISIBLE_COUNT 条到末尾，保证循环回首时视觉无缝
    if (this.needsCarousel) {
      for (let i = 0; i < VISIBLE_COUNT; i++) {
        track.appendChild(this._buildChip(list[i]));
      }
    }

    this.container.replaceChildren(track);
    this.track = track;
    this.show();

    if (this.needsCarousel) this.start();
  }

  /** @param {string} text */
  _buildChip(text) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'chip';
    btn.textContent = `[ ${text} ]`;
    btn.setAttribute('aria-label', `推荐问题：${text}`);
    btn.addEventListener('click', () => this.onSelect(text));
    return btn;
  }

  /** 启动轮播 */
  start() {
    this.stop();
    if (!this.needsCarousel) return;
    this.timer = setInterval(() => this._tick(), INTERVAL_MS);
  }

  /** 停止轮播 */
  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
      this.resetTimer = null;
    }
  }

  _tick() {
    this.index++;
    this._applyTransform();

    // 已滚入克隆区末尾（视觉上等于回到首部），等动画结束后无动画重置
    if (this.index >= this.list.length) {
      this.resetTimer = setTimeout(() => {
        if (!this.track) return;
        this.track.classList.add('action-chips__track--no-anim');
        this.index = 0;
        this._applyTransform();
        // 强制 reflow 后恢复动画类
        void this.track.offsetHeight;
        this.track.classList.remove('action-chips__track--no-anim');
        this.resetTimer = null;
      }, TRANSITION_MS);
    }
  }

  _applyTransform() {
    if (!this.track || !this.track.firstElementChild) return;
    const chipH = this.track.firstElementChild.offsetHeight;
    const gap = parseInt(getComputedStyle(this.track).gap, 10) || 0;
    const step = chipH + gap;
    this.track.style.transform = `translateY(-${this.index * step}px)`;
  }
}
